<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                            <i class="fa fa-chevron-circle-left"></i> {{$t('text.globals.back')}}
                        </a>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <h2 class="mb-2">
                            <i class="fas fa-vial"></i> {{$t('text.cacheTestClient.cacheTestClient')}}
                        </h2>

                        <div class="alert alert-warning mb-3">
                            <b>{{$t('text.cacheTestClient.openBrowserWithCustomSettingsPrompt')}}</b><br/><br/>

                            <div class="card card-body p-3">
                            <b-tabs content-class="">
                                <b-tab :title="$t('text.cacheTestClient.disableSecurityChromeWindowsTitle')" active
                                       class="card border-top-0 card-body"
                                       style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
                                    <pre><code>{{$t('text.cacheTestClient.disableSecurityChromeWindowsCommand')}}</code></pre>
                                </b-tab>
                                <b-tab :title="$t('text.cacheTestClient.disableSecurityChromeMacOsTitle')"
                                       class="card border-top-0 card-body"
                                       style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
                                    <pre><code>{{$t('text.cacheTestClient.disableSecurityChromeMacOsCommand')}}</code></pre>
                                </b-tab>
                                <b-tab :title="$t('text.cacheTestClient.disableSecurityChromeLinuxTitle')"
                                       class="card border-top-0 card-body"
                                       style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
                                    <pre><code>{{$t('text.cacheTestClient.disableSecurityChromeLinuxCommand')}}</code></pre>
                                </b-tab>
                            </b-tabs>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8 mt-2 mb-5">

                        <div class="form form-condensed">
                            <div class="form-group">
                                <label for="host">{{$t('text.cacheTestClient.cacheUrl')}}</label>
                                <input trim type="text" class="form-control mr-0" id="host" aria-describedby="host"
                                       v-model="host" name="host">
                            </div>
                            <div class="form-group">
                                <label for="file_id">{{$t('text.cacheTestClient.documentUuid')}}</label>
                                <input trim type="text" class="form-control mr-0" id="file_id"
                                       aria-describedby="file_id"
                                       v-model="file_id" name="file_id" @keyup.enter="updateFileId(file_id)">
                            </div>
                            <div class="form-group mt-5">
                                <b-button variant="secondary" size="sm" class="m-0" @click="updateFileId(file_id)">
                                    {{$t('text.cacheTestClient.getDocumentMetadata')}}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="fileId">
                    <div class="col-md-12">
                        <b-tabs content-class="">
                            <b-tab :title="$t('text.cacheTestClient.documentDetailsViaAlfresco')" active
                                   class="card border-top-0 card-body"
                                   style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
                                <DocumentDetailsComponent
                                        key="alfresco"
                                        :showLoadTimes="true"
                                        :fileId="fileId"
                                        :location="'alfresco'"
                                        :host="host"
                                ></DocumentDetailsComponent>
                            </b-tab>

                            <b-tab :title="$t('text.cacheTestClient.documentDetailsViaCache')" class="card border-top-0 card-body"
                                   style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
                                <DocumentDetailsComponent
                                        key="cache"
                                        :showLoadTimes="true"
                                        :fileId="fileId"
                                        :location="'cache'"
                                        :host="host"
                                ></DocumentDetailsComponent>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import DocumentDetailsComponent from '../components/DocumentDetailsComponent';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';


    export default {
        name: 'DocumentDetails',
        components: {
            Vue,
            DocumentDetailsComponent,
            Loading,
            vSelect
        },

        data() {
            return {
                file_id: null,
                fileId: null,
                host: 'http://vm-alfresco-test-1:8181/'
            };
        },

        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        watch: {
            '$route': function () {
                this.fileId = this.$route.params.id;
            }
        },

        mounted() {

        },

        computed: {},

        methods: {
            updateFileId(file_id) {
                const _this = this;

                _this.fileId = file_id;
                _this.$forceUpdate();
            }

        }


    };
</script>



// WEBPACK FOOTER //
// src/pages/CacheTestClient.vue